import { useState, useEffect } from "react";

/* ═══════════════════════════════════════════════════════════════════════════
   useReportTheme — shared theme used across the Reports surface
   (DefaultReportView, MainReports/ReportInput, ReportDocument, …)

   Returns: { ...themeColors, isDark }
   ═══════════════════════════════════════════════════════════════════════════ */

export const REPORT_THEMES = {
  dark: {
    badgeBg: "rgba(14,165,233,0.10)",
    badgeBorder: "rgba(14,165,233,0.22)",
    badgeText: "#38bdf8",
    labelBg: "rgba(255,255,255,0.06)",
    labelBorder: "rgba(255,255,255,0.10)",
    labelText: "#a1a1aa",
    textPrimary: "#f4f4f5",
    textSecondary: "#d4d4d8",
    textMuted: "#71717a",
    divider: "rgba(255,255,255,0.08)",
    pageBg: "#121C2E",
    cardBg: "rgba(255,255,255,0.03)",
    cardBorder: "rgba(255,255,255,0.08)",
    innerBg: "rgba(255,255,255,0.04)",
    accent: "#0EA5E9",
  },
  light: {
    badgeBg: "rgba(14,165,233,0.08)",
    badgeBorder: "rgba(14,165,233,0.20)",
    badgeText: "#0284c7",
    labelBg: "rgba(0,0,0,0.04)",
    labelBorder: "rgba(0,0,0,0.10)",
    labelText: "#71717a",
    textPrimary: "#18181b",
    textSecondary: "#3f3f46",
    textMuted: "#a1a1aa",
    divider: "rgba(0,0,0,0.08)",
    pageBg: "#e4eaf2",
    cardBg: "#ffffff",
    cardBorder: "rgba(0,0,0,0.08)",
    innerBg: "rgba(0,0,0,0.03)",
    accent: "#2d3d52",
  },
};

export const useReportTheme = () => {
  const [dark, setDark] = useState(() =>
    document.documentElement.classList.contains("dark"),
  );
  useEffect(() => {
    const obs = new MutationObserver(() =>
      setDark(document.documentElement.classList.contains("dark")),
    );
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => obs.disconnect();
  }, []);
  return {
    ...(dark ? REPORT_THEMES.dark : REPORT_THEMES.light),
    isDark: dark,
  };
};

export default useReportTheme;
